import { v4 as uuidv4 } from "uuid";
import { WORLD_SCALE, WORLD_SNAP } from "../constants";

export const w2p    = mm => mm * WORLD_SCALE;
export const w2pt   = p  => ({ x: w2p(p.x), y: w2p(p.y) });
export const s2w    = (sp, pan, zoom) => ({ x: (sp.x - pan.x) / zoom / WORLD_SCALE, y: (sp.y - pan.y) / zoom / WORLD_SCALE });
export const w2s    = (wp, pan, zoom) => ({ x: w2p(wp.x) * zoom + pan.x, y: w2p(wp.y) * zoom + pan.y });
export const snapW  = v => Math.round(v / WORLD_SNAP) * WORLD_SNAP;
export const snapWP = p => ({ x: Math.round(snapW(p.x)), y: Math.round(snapW(p.y)) });
export const intP   = p => ({ x: Math.round(p.x), y: Math.round(p.y) });
export const mm2cm  = mm => Math.round(mm / 10);
export const mm2m   = mm => (mm / 1000).toFixed(2);
export const mm2m2  = a  => (a / 1e6).toFixed(2);
export const izoom  = zoom => 1 / (WORLD_SCALE * zoom);
export const inr    = n => "₹" + Math.round(n).toLocaleString("en-IN");

/** Generates a prefixed short ID using uuid v4 — e.g. "n_3f2a1b4c" */
export const mkId = prefix => `${prefix}_${uuidv4().slice(0, 8)}`;
